var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5258 35.7572C29.4579 31.9644 35.4141 29.464 38.3943 28.2559C46.9034 24.8066 48.6715 24.2074 49.8239 24.1872C50.0773 24.1832 50.644 24.2445 51.0112 24.5348C51.3212 24.7799 51.4065 25.1111 51.4473 25.3435C51.4881 25.5759 51.5389 26.1053 51.4985 26.519C51.0374 31.2409 49.0422 42.6997 48.0271 47.9883C47.5977 50.2261 46.7519 50.9764 45.9331 51.0498C44.1538 51.2094 42.8027 49.9038 41.0794 48.8028C38.3826 47.0799 36.8592 46.0074 34.2415 44.3263C31.2164 42.3834 33.1775 41.3156 34.9015 39.5704C35.3527 39.1137 43.1924 32.1639 43.3441 31.5335C43.3631 31.4546 43.3807 31.1607 43.2015 31.0055C43.0224 30.8503 42.758 30.9034 42.5672 30.9455C42.2967 31.0054 37.9887 33.7806 29.6431 39.271C28.4202 40.0894 27.3127 40.4881 26.3203 40.4672C25.2262 40.4442 23.1218 39.8643 21.5574 39.3687C19.6386 38.7609 18.1135 38.4394 18.2463 37.4071C18.3155 36.8693 19.0753 36.3194 20.5258 35.7572Z",
    fill: "#56A2E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.6207c8633eef60f4827c598176694dfc.svg";
export { ForwardRef as ReactComponent };